import { render, staticRenderFns } from "./CalendarListNew.vue?vue&type=template&id=6a2da7b6&scoped=true"
import script from "./CalendarListNew.vue?vue&type=script&lang=js"
export * from "./CalendarListNew.vue?vue&type=script&lang=js"
import style0 from "./CalendarListNew.vue?vue&type=style&index=0&id=6a2da7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2da7b6",
  null
  
)

export default component.exports